import util from '@bmp-vue/core/api/util'
const controller = 'BancoApia'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get () {
    return [
      { modelo: 0, prazoInicio: 1, prazoFim: 23, taxa: 1.81 },
      { modelo: 0, prazoInicio: 24, prazoFim: 35, taxa: 1.54 },
      { modelo: 0, prazoInicio: 36, prazoFim: 47, taxa: 1.52 },
      { modelo: 0, prazoInicio: 48, prazoFim: 60, taxa: 1.46 },
      { modelo: 1, prazoInicio: 1, prazoFim: 23, taxa: 2.03 },
      { modelo: 1, prazoInicio: 24, prazoFim: 35, taxa: 1.68 },
      { modelo: 1, prazoInicio: 36, prazoFim: 47, taxa: 1.62 },
      { modelo: 1, prazoInicio: 48, prazoFim: 60, taxa: 1.62 },
      { modelo: 2, prazoInicio: 1, prazoFim: 23, taxa: 2.24 },
      { modelo: 2, prazoInicio: 24, prazoFim: 35, taxa: 1.79 },
      { modelo: 2, prazoInicio: 35, prazoFim: 47, taxa: 1.70 },
      { modelo: 2, prazoInicio: 48, prazoFim: 60, taxa: 1.67 },
      { modelo: 3, prazoInicio: 1, prazoFim: 23, taxa: 2.30 },
      { modelo: 3, prazoInicio: 24, prazoFim: 35, taxa: 1.86 },
      { modelo: 3, prazoInicio: 36, prazoFim: 47, taxa: 1.77 },
      { modelo: 3, prazoInicio: 48, prazoFim: 60, taxa: 1.71 }
    ]
  },
  ModeloCalculoEnum: {
    Price: 1,
    SAC: 2
  },
  ImportaAssinante (th, request, importEmitente) {
    if (importEmitente) {
      th.$api.Multiplo.Post('InsertCCBDigitalAssinatura', request).then(function (response) {
        th.$api.UI.PostAction(response, 'Importação realizada com sucesso!')
      })
    }
  },
  SavePropostaCampoAuxiliar (th, codigoProposta) {
    const campos = []

    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: codigoProposta || th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }
    if ([null, undefined].indexOf(th.model.DtoConsultaMotor) < 0) { campos.push({ CodigoProposta: codigoProposta || th.model.Codigo, NomeCampo: 'PROPOSTA_CONSULTAMOTOR', ValorCampo: JSON.stringify(th.model.DtoConsultaMotor) }) }
    if ([null, undefined].indexOf(th.model.isProdutorRural) < 0) { campos.push({ CodigoProposta: codigoProposta || th.model.Codigo, NomeCampo: 'PROPOSTA_PRODUTORRURAL', ValorCampo: th.model.isProdutorRural }) }

    return th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos })
  },
  CarregaDiasAcrescimo (th, value) {
    return th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), value)
  },
  GetDocumentos (th, tipoPessoa) {
    var list = []
    if (tipoPessoa === th.$aux.TipoPessoaEnum.PF) {
      list.push({ text: 'RG', value: 4 })
      list.push({ text: 'CNH - Digital', value: 17 })
      list.push({ text: 'Comprovante Endereço', value: 6 })
      list.push({ text: 'Comprovante Renda', value: 7 })
      return list
    } else {
      list.push({ text: 'Comprovante Endereço', value: 6 })
      list.push({ text: 'Contrato Social', value: 20 })
      list.push({ text: 'Faturamento', value: 33 })
      return list
    }
  },
})

export default ctrl
